import React from 'react';

// eslint-disable-next-line react/prop-types
const Placeholder = ({ width, classes }) => {
  classes = classes || '';

  return <div style={{ width }} className={`loading-animation ${classes}`} />;
};

export default Placeholder;
